import type { AutocompleteOption } from './Autocomplete'

export type AutocompleteRow = { type: 'header'; key: string; label: string } | { type: 'option'; option: AutocompleteOption }

// Headers are derived from the FILTERED options so a group whose options all get searched out
// loses its header too, instead of leaving a label with nothing under it. Group order is taken
// from the full (unfiltered) `options` list so groups don't visually reorder while typing.
export const buildRows = (options: AutocompleteOption[], filtered: AutocompleteOption[], showGroupCounts = false): AutocompleteRow[] => {
    const hasGroups = options.some((option) => option.group)
    if (!hasGroups) return filtered.map((option) => ({ type: 'option', option }))

    const groupOrder = Array.from(new Set(options.map((option) => option.group ?? '')))
    const rows: AutocompleteRow[] = []
    for (const group of groupOrder) {
        const groupOptions = filtered.filter((option) => (option.group ?? '') === group)
        if (groupOptions.length === 0) continue
        rows.push({ type: 'header', key: group, label: showGroupCounts ? `${group} (${groupOptions.length})` : group })
        rows.push(...groupOptions.map((option): AutocompleteRow => ({ type: 'option', option })))
    }
    return rows
}
